import { ExternalJobDto } from "./externalJob.dto";

export class XmlFeedCheckResults {
    success: boolean = false;
    explanation: string = '';
    jobs: ExternalJobDto[] = [];
}